import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import useDomain from '@/hooks/useDomain';
import { keywordResearchTooltips } from '@/app/KeywordResearch/tooltip/keywordResearchTooltips';
import {
  hasEnoughKeywordsForCluster,
  isClusterFromTaskDisabled,
  submitClusterFromTask,
  type ClusterFromTaskBody,
  type ClusterFromTaskResult
} from '@/app/KeywordResearch/utils/clusterFromTask';

type ClusterMutate = (
  body: ClusterFromTaskBody
) => { unwrap: () => Promise<ClusterFromTaskResult> };

type ClusterFromTaskButtonProps = {
  taskId?: string;
  keywordCount?: number;
  mutate: ClusterMutate;
  isClustering: boolean;
  isTaskReady?: boolean;
};

const ClusterFromTaskButton = ({
  taskId,
  keywordCount = 0,
  mutate,
  isClustering,
  isTaskReady = true
}: ClusterFromTaskButtonProps) => {
  const { domain_slug, domain } = useDomain();
  const navigate = useNavigate();
  const hasEnoughKeywords = hasEnoughKeywordsForCluster(keywordCount);
  const disabled = isClusterFromTaskDisabled({
    isClustering,
    taskId,
    keywordCount,
    isTaskReady
  });

  const tooltipContent = !hasEnoughKeywords
    ? keywordResearchTooltips.clustering.clusterFromTaskMinKeywords
    : !isTaskReady
      ? keywordResearchTooltips.clustering.clusterFromTaskNotReady
      : keywordResearchTooltips.clustering.clusterFromTask;

  const handleClick = () => {
    void submitClusterFromTask({
      mutate,
      taskId,
      domainSlug: domain_slug ?? undefined,
      domain: domain ?? undefined,
      navigate,
      hasEnoughKeywords
    });
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="cluster-from-task-tooltip">{tooltipContent}</Tooltip>
      }
    >
      <span className="d-inline-block">
        <Button
          variant="falcon-primary"
          size="sm"
          className="d-flex align-items-center gap-1"
          disabled={disabled}
          style={disabled ? { pointerEvents: 'none' } : undefined}
          onClick={handleClick}
        >
          <FontAwesomeIcon icon="project-diagram" />
          <span>{isClustering ? 'در حال ارسال...' : 'خوشه بندی کن'}</span>
        </Button>
      </span>
    </OverlayTrigger>
  );
};

export default ClusterFromTaskButton;
